<template>
    <div>
        <b-modal :id="modalId"
                @hidden="onModalHidden()"
                 modal-class="modal-add-to-cart"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body">
                    <img src="@/assets/icon/ic-cart.svg" alt="" class="modal-body-img">
                    <div class="modal-body-txt">เพิ่มสินค้าในตะกร้าสำเร็จ</div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {AddToCartModalController} controller (required) /components/Modal/Controller/AddToCartModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "AddToCartModal",
    props: {
        // busModal: Object,
        theme: String,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            title: '',
            tag: '',
            message: '',
            btnOk: '',
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);

            setTimeout(() => {
                this.hide();
            }, 1000);
        
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-add-to-cart {
        @extend %modal-base;

        .modal-dialog {
            max-width: 180px;

            .modal-content {
                border-radius: 16px;
                background: rgba(51, 51, 51, 0.80);
            }
        }
        .modal-base-body {
            .modal-body-img {
                width: 32px;
                height: 32px;
                display: block;
                margin: auto;
            }

            .modal-body-txt {
                font-size: 0.875rem !important;
                font-family: $regular;
                line-height: normal;
                margin-top: 10px;
                color: #ffffff;
            }
            // padding:10px 0 30px;

            // #alert_msg {
            //     width: 100%;
            //     text-align: center;
            // }
        }
    }
</style>
